import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import LoadingSpinner from '@/components/ui/LoadingSpinner'
import { useShopPreferences } from '@/hooks/useShopPreferences'
import {
  isCustomerPortalSectionEnabled,
  parseCustomerPortalSettings,
  type CustomerPortalSectionKey,
} from '@/lib/customerPortalSettings'

interface CustomerPortalSectionGuardProps {
  section: CustomerPortalSectionKey
  children: ReactNode
}

/** Redirects to the customer dashboard when the shop has disabled this portal section. */
const CustomerPortalSectionGuard = ({ section, children }: CustomerPortalSectionGuardProps) => {
  const { shop, isLoading } = useShopPreferences()

  if (isLoading && !shop) {
    return (
      <div className="flex justify-center py-20">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  const settings = parseCustomerPortalSettings(shop?.customer_portal_settings)
  if (!isCustomerPortalSectionEnabled(settings, section)) {
    return <Navigate to="/customer" replace />
  }

  return <>{children}</>
}

export default CustomerPortalSectionGuard
